import { styled } from '@clickcease/cc-client-components-lib'

export const ScheduleCallModalTitlesWrapper = styled('div', {
  fontSize: '20px',
  position: 'relative',
  bottom: '44px',
})

export const ScheduleCallModalTitle = styled('div', {
  fontSize: '36px',
  fontWeight: '700',
  color: '#34163E',
  textAlign: 'center',
})
export const ScheduleCallModalSubTitle = styled('div', {
  fontSize: '20px',
  fontWeight: '400',
  textAlign: 'center',
  marginBottom: '20px',
})

export const ScheduleCallModalStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  padding: '$8 $12',
  textAlign: 'left',
  gap: '20px',
  position: 'relative',
  bottom: '30px',
})

export const PhoneErrorStyled = styled('div', {
  color: '$error',
  fontWeight: '$l',
  fontSize: '$md',
  textAlign: 'left',
})

export const EmailErrorStyled = styled('div', {
  color: '$error',
  fontWeight: '$l',
  fontSize: '$md',
  textAlign: 'left',
})
